export const DEFAULT_SHIPMENT_PROVIDER = "DHL";

export const SHIPMENT_PROVIDER_URL_CONTEXT_KEY = "shipmentProviderUrl";

export const SHIPMENT_PROVIDER_CONTEXT_KEY = "shipmentProvider";

export const TRACKING_URL_CONTEXT_KEY = "trackingUrl";

export const TRACKING_NUMBER_CONTEXT_KEY = "trackingNumber";

export const SHIPMENT_PROVIDER_LIST = [
    {
        id: "DHL",
        value: "DHL",
        key:"dhl"
    },
    {
        id: "DHL Express",
        value: "DHL Express",
        key:"dhl_express"
    },
    {
        id: "Swiss Post",
        value: "Swiss Post",
        key:"swiss_post"
    },
    {
        id: "Fedex",
        value: "Fedex",
        key:"fedex"
    },
];



// WEBPACK FOOTER //
// ./src/modules/logistic/util/ShipmentProviderUtil.js